import React from "react"
import { makeStyles } from "@material-ui/core/styles"
import Popover from "@material-ui/core/Popover"
import Typography from "@material-ui/core/Typography"
import Button from "@material-ui/core/Button"

const useStyles = makeStyles((theme) => ({
	typography: {
		padding: theme.spacing(2),
	},
}))

export default function SimplePopover({ btninfo }) {
	const classes = useStyles()
	const [anchorEl, setAnchorEl] = React.useState(null)

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget)
	}

	const handleClose = () => {
		setAnchorEl(null)
	}

	const open = Boolean(anchorEl)
	const id = open ? "simple-popover" : undefined

	return (
		<div>
			<Button
				aria-describedby={id}
				className="btn btn-default btn-sm rounded-circle"
				style={{ boxShadow: "none" }}
				onClick={handleClick}
			>
				<i className="bi bi-question-circle-fill" style={{ fontSize: "18px" }}></i>
			</Button>
			<Popover
				id={id}
				open={open}
				anchorEl={anchorEl}
				onClose={handleClose}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "center",
				}}
				transformOrigin={{
					vertical: "top",
					horizontal: "center",
				}}
			>
				<Typography className={classes.typography}>
					{btninfo === "searchBuild" ? "The content of the searchBuild Popover." : null}
					{btninfo === "filtersBuild" ? "The content of the filtersBuild Popover." : null}
					{btninfo === "target" ? "The content of the target Popover." : null}
					{btninfo === "includeSpecific" ? "The content of the includeSpecific Popover." : null}
					{btninfo === "ignoreRelated" ? "The content of the ignoreRelated Popover." : null}
					{btninfo === "ignoreSpecific" ? "The content of the ignoreSpecific Popover." : null}
				</Typography>
			</Popover>
		</div>
	)
}
